import { render, staticRenderFns } from "./ResolvedPetitionsList.vue?vue&type=template&id=e196f870"
import script from "./ResolvedPetitionsList.vue?vue&type=script&lang=js"
export * from "./ResolvedPetitionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports